<script>
    
    import AudioMeter from "./AudioMeter.svelte";
    
    export let meterSource;
    export let peerType;
    export let peerId;
    export let channelNum = -1;
    export let compact = false;
    //const label = peerType === "talent" ? "input" : "speaker";
    const label = "";

</script>

<div class="indicatorWrapper" class:compact>
    <div class="indicator" class:compact>
        <AudioMeter meterSource={meterSource} peerType={peerType} peerId={peerId} isMuted={false} channelNum={channelNum}/>
    </div>
    {#if label !== ""}
        <p class="indicatorLabel">{label}</p>
    {/if}
</div>

<style lang="scss">
    
    @import "../styles/main.scss";

    .indicator {
        //this overrides the 10px flex gap that is applied by the parent
        margin-left: -7px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        // width: 38px;
        
        border-radius: 8px;

        background: linear-gradient(
            145deg,
            rgba(60, 65, 81, 0.25) 0%,
            rgba(40, 43, 54, 0.35) 100%
        );

        &.muted {
            background: linear-gradient(145deg, rgba(90, 30, 35, 0.25) 0%, rgba(60, 20, 25, 0.35) 100%);
        }

        &.compact {
            margin-left: 0;
        }
    }

    .indicatorWrapper {
        height: 48px;
        padding-top: 4px;
        padding-right: 1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        &.compact {
            height: 28px;
            padding: 0;
            flex-direction: row;
            gap: 4px;
        }
    }

    .indicatorLabel {
        font-size: 0.85rem;
        color: rgba(190, 157, 134, 0.7);
        font-weight: 300;
        letter-spacing: 0.5px;
        text-transform: lowercase;
        white-space: pre-line;
    }
</style>